import ZendeskOps from '@/components/ZendeskOps';

const ZendeskOpsPage = () => {
  return <ZendeskOps />;
};

export default ZendeskOpsPage;
